/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import All from './All/index'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/TxPlanNotes/Content/Content",
  onChange,
  isInvalid
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let txPlanNoteNoteValueData = fromData.useDataValue({ viewPath,
context: 'tx_plan_note',
path: 'note',
})
let txPlanNoteNoteIsValidData = fromData.useDataIsValid({ viewPath,
context: 'tx_plan_note',
path: 'note',
validate: fromValidate.textInput,
})
let txPlanNoteNoteChangeData = fromData.useDataChange({ viewPath,
context: 'tx_plan_note',
path: 'note',
})
  return (<React.Fragment
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 marginTop={dtSpaceXxs}
 marginLeft={dtSpaceXxs}
 height={224}
 resize="none"
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaTextareaLabel
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Tx Plan Notes"
/>
<All
  viewPath={`${viewPath}/All`}
/>
</div>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
 data="tx_plan_note.note"
 validate="/Data/validate.js textInput"
 onChange={txPlanNoteNoteChangeData}
 value={txPlanNoteNoteValueData}
 isInvalid={!txPlanNoteNoteIsValidData}
 data="tx_plan_note"
/>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}